<template>
  <div class="penandatangan-select">
    <a-row :gutter="24" class="row-penandatangan">
      <a-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="form-section">
          <label class="section-label label-grey"
            >Penandatangan 1 (Sisi Kiri) <span class="required">*</span></label
          >
          <a-select
            :value="kiriValue"
            placeholder="Cari nama pengurus"
            :options="pengurusOptions"
            class="full-width"
            :class="{ 'field-error': kiriError }"
            show-search
            :filter-option="filterOption"
            :disabled="disabled"
            @change="handleKiriChange"
          />
          <span v-if="kiriError" class="error-hint">
            {{ kiriError }}
          </span>
        </div>
      </a-col>
      <a-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="form-section">
          <label class="section-label label-grey">Penandatangan 2 (Sisi Kanan)</label>
          <a-select
            :value="kananValue"
            placeholder="Cari nama pengurus"
            :options="pengurusOptions"
            class="full-width"
            allow-clear
            show-search
            :filter-option="filterOption"
            :disabled="disabled"
            @change="handleKananChange"
          />
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'PenandatanganSelect',
  props: {
    kiriValue: {
      type: String,
      default: null,
    },
    kananValue: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    kiriError: {
      type: String,
      default: null,
    },
  },
  emits: ['update:kiriValue', 'update:kananValue'],
  setup(props, { emit }) {
    const store = useStore()

    // Filter out admin and super_admin roles - they should not be penandatangan
    const pengurusOptions = computed(() => {
      const options = store.state.suratKeluar.pengurusOptions || []
      const pengurusMap = store.state.suratKeluar.pengurusMap || {}
      return options.filter(option => {
        const user = pengurusMap[option.value]
        if (user && user.role) {
          const role = user.role.toLowerCase()
          return role !== 'admin' && role !== 'super_admin' && role !== 'pekerja_harian'
        }
        return true
      })
    })

    const filterOption = (input, option) => {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }

    const handleKiriChange = value => {
      emit('update:kiriValue', value)
    }

    const handleKananChange = value => {
      emit('update:kananValue', value)
    }

    return {
      pengurusOptions,
      filterOption,
      handleKiriChange,
      handleKananChange,
    }
  },
})
</script>

<style lang="scss" scoped>
.penandatangan-select {
  margin-bottom: 24px;

  .form-section {
    .section-label {
      display: block;
      font-weight: 500;
      color: #262626;
      margin-bottom: 8px;
      font-size: 14px;

      .required {
        color: #ff4d4f;
      }
    }

    .error-hint {
      display: block;
      color: #f5222e;
      font-size: 14px;
      margin-top: 4px;
    }
  }

  :deep(.field-error .ant-select-selector) {
    border-color: #f5222e !important;
  }
  :deep(.ant-select-selection-placeholder) {
    color: #798892 !important;
  }
  .full-width {
    width: 100%;
  }
}

.row-penandatangan {
  @media (max-width: 768px) {
    display: flex !important;
    flex-direction: column !important;
    gap: 20px !important;
  }
}
</style>
